import { render, staticRenderFns } from "./payment-method-wrapper.component.vue?vue&type=template&id=1d8d8479&"
import script from "./payment-method-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./payment-method-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports